var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCalendarRound = function SvgCalendarRound(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Calendar Round",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "AZ_DLS_Icons",
    transform: "translate(-297.000000, -345.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Library_Items-/-Title-/-Descriptions-Copy-8",
    transform: "translate(33.000000, 292.000000)",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 16,
    letterSpacing: -0.0266666671
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 1.086957)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Calendar",
    transform: "translate(297.000000, 345.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,2 C16.5128358,2 16.9355072,2.38604019 16.9932723,2.88337887 L17,3 L17,4 L20,4 C21.0543618,4 21.9181651,4.81587779 21.9945143,5.85073766 L22,6 L22,20 C22,21.1045695 21.1045695,22 20,22 L20,22 L4,22 C2.8954305,22 2,21.1045695 2,20 L2,20 L2,6 C2,4.8954305 2.8954305,4 4,4 L4,4 L7,4 L7,3 C7,2.44771525 7.44771525,2 8,2 C8.51283584,2 8.93550716,2.38604019 8.99327227,2.88337887 L9,3 L9,4 L15,4 L15,3 C15,2.44771525 15.4477153,2 16,2 Z M20,10 L4,10 L4,20 L20,20 L20,10 Z M20,6 L4,6 L4,8 L20,8 L20,6 Z",
    id: "Combined-Shape"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCalendarRound);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "calendar-round.2bc5b539b311d48ab7fb5d2854534ae6.svg";